<script setup>
/* eslint-disable */
import { ref, computed, watch } from 'vue';
import { useFixtureStore } from '@/stores/fixture';
import { useMarketsStore } from '@/stores/markets';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useDatesStore } from '@/stores/dates';
import { useRouter } from 'vue-router';

import FeaturedFixtureOverviewOdd from '@/components/pre_sports/FeaturedFixtureOverviewOdd.vue';
import JerseyIcon from '@/assets/svgs/jerseyIcon.vue';
const fixtureStore = useFixtureStore();
const marketsStore = useMarketsStore();
const preSportsStore = usePreSportsStore();
const datesStore = useDatesStore();
const liveSportsStore = useLiveSportsStore();


const router = useRouter();

const props = defineProps({
	fixture: {
		type: Object,
		required: true,
	},
});

const goToFixture = () => {
	if (!props.fixture.live) router.push({ name: 'pre-sports-fixturebook', params: { sport_id: props.fixture.sport_id, region_id: props.fixture.region_id, competition_id: props.fixture.competition_id, fixture_id: props.fixture.id } } )
	else router.push( { name: 'live-sports-eventview', params: { fixture_id: props.fixture.id } } );
}

const primary_overview_market = ref(marketsStore.sportOverviewMarkets(props.fixture.sport_id, false)[0]);

const primaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(primary_overview_market.value.slug)) return [];

	return props.fixture.overview_markets[primary_overview_market.value.slug];
});

const getImageUrl = computed(() => {
	if (props.fixture.highlight_image_url) {
		return process.env.VUE_APP_STORAGE_URL + 'highlights/' + props.fixture.highlight_image_url;
	}

	if (props.fixture.competition_image_url) {
		return process.env.VUE_APP_STORAGE_URL + 'competitions_images/' + props.fixture.competition_image_url;
	}

	return '/assets/default_competition_images/comp-' + preSportsStore.preSportName(props.fixture.sport_id) + '.jpg';
});

watch(() => props.fixture.sport_id, (newSportId) => {
	primary_overview_market.value = marketsStore.sportOverviewMarkets(newSportId, false)[0]
})

</script>
<template>
	<div class="league-slide-item">
		<div class="live-legaue-card" :class="props.fixture.live ? 'live-league-match' : '' ">
			<div class="live-card-inner">
				<div class="live-card-image">
					<img :src="getImageUrl" alt="promo-card-1">
				</div>
				<div class="live-card-content">
					<div class="league-title" @click="goToFixture">
						<div class="title">
							<svg  class="normal-img"
								xmlns="http://www.w3.org/2000/svg"
								xml:space="preserve"
								version="1.1"
								style="width:23px; fill: none; stroke: var(--white); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
								viewBox="0 0 30 25"
								xmlns:xlink="http://www.w3.org/1999/xlink">
								<use :xlink:href="preSportsStore.preSportWhiteIcon(props.fixture.sport_id) + '#svg3108'" stroke-width="1px"  />
							</svg>
							<!-- <img :src="preSportsStore.preSportWhiteIcon(props.fixture.sport_id)" alt=""> -->
							<h6>{{ props.fixture.competition_name }}</h6>
						</div>
						<div class="score_time">
							<span>{{ datesStore.preFixtureBookDate(props.fixture.start_datetime) }}</span> - <span> {{ datesStore.preFixtureBookTime(props.fixture.start_datetime) }}</span>
						</div>
						<div class="live-info-data">
							<!-- <div class="live-badge" v-html="svg_data.live_badge"></div> -->
							<div class="live-data-desktop" v-if="liveSportsStore.hasFixtureClock(props.fixture.sport_id)">
								<h3>
									<dl>
										{{ fixtureStore.fixtureClockTime(props.fixture) }}
										<dt> {{ fixtureStore.fixtureState(props.fixture) }}</dt>
									</dl>

									<span></span>
								</h3>
							</div>
							<div class="live-data-desktop" v-else>
								<h3 >{{ fixtureStore.fixtureState(props.fixture) }}</h3>
								<span></span>
							</div>
						</div>
					</div>

					<div class="team-info" @click="goToFixture">
						<div class="team-info-inner">
							<div class="playing-team-jersey">
								<img v-if="fixtureStore.getParticipantLogo(props.fixture.participant_logos)" :src="fixtureStore.getParticipantLogo(props.fixture.participant_logos).home" alt="#">
								<JerseyIcon :size="24" v-if="!fixtureStore.getParticipantLogo(props.fixture.participant_logos) && fixtureStore.getParticipantJersey(props.fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(props.fixture.jersey_colors).home" />
							</div>
							<div class="team-title">
								<h4>{{ props.fixture.participants? props.fixture.participants[0] : ''}}</h4>
							</div>
							<!-- <div class="team-shirt">
								<img src="@/assets/images/team-left.png" alt="">
							</div> -->
						</div>

						<div class="divider">
							-
						</div>

						<div class="team-info-inner" v-if="!liveSportsStore.hasOneParticipant(props.fixture.sport_id)">
							<!-- <div class="team-shirt">
								<img src="@/assets/images/team-right.png" alt="">
							</div> -->
							<div class="team-title">
								<h4>{{ props.fixture.participants? props.fixture.participants[1] : ''}}</h4>
							</div>
							<div class="playing-team-jersey">
								<img v-if="fixtureStore.getParticipantLogo(props.fixture.participant_logos)" :src="fixtureStore.getParticipantLogo(props.fixture.participant_logos).away" alt="#">
								<JerseyIcon :size="24" v-if="!fixtureStore.getParticipantLogo(props.fixture.participant_logos) && fixtureStore.getParticipantJersey(props.fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(props.fixture.jersey_colors).away" />
							</div>
						</div>

					</div>

					<div class="betting_info" :class="{'way2': !primary_overview_market.three_way}">
						<FeaturedFixtureOverviewOdd
							:overview_market_header_name="primary_overview_market.odd_names[0]"
							:overview_odd="primaryOverviewMarketOdds[0]"
							:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
							:fixture_id="props.fixture.id"
						/>

                        <FeaturedFixtureOverviewOdd v-if="primary_overview_market.three_way"
							:overview_market_header_name="primary_overview_market.odd_names[1]"
							:overview_odd="primaryOverviewMarketOdds[1]"
							:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
							:fixture_id="props.fixture.id"
						/>

						<FeaturedFixtureOverviewOdd
							:overview_market_header_name="primary_overview_market.odd_names[2]"
							:overview_odd="primary_overview_market.three_way ? primaryOverviewMarketOdds[2] : primaryOverviewMarketOdds[1]"
							:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
							:fixture_id="props.fixture.id"
						/>
					</div>

				</div>
			</div>
		</div>

	</div>
</template>

<style scoped>
 .live-legaue-card .live-card-inner .live-card-image img {
	mix-blend-mode: unset !important;
}
.playing-team-jersey{
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: flex-start;
}

.playing-team-jersey img{
	width: 1.5rem;
	height: 1.5rem;
	margin: 0 0.2rem;
}

@media screen and (min-width: 1913px) and (max-width: 1930px) {
    .league-slider-main .wrapper .league-slide-item {
        width: 20.2vw !important;
    }
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card {
    position: relative;
    height: 100%;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner {
    grid-template-columns: 1fr;
    height: 100%;
    transition: .3s ease-in-out;
    background: transparent;
}


.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-image {
    position: absolute;
    height: 100%;
    width: 100%;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-image:before {
    content: "";
    background: linear-gradient(315deg, var(--primary), var(--dark));
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-image:after {
    content: "";
    background: var(--dark);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    opacity: 75%;
    z-index: 2;
    mix-blend-mode: multiply;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-image img {
    mix-blend-mode: luminosity;
    z-index: 1;
    position: relative;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content {
    padding: 20px;
    min-height: 160px;
    padding: 23px 30px;
    display: grid;
    z-index: 10;


    grid-auto-columns: unset;
    grid-gap: unset;
    grid-auto-flow: unset;
    background: unset;
    border: unset;
}



.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding: 0;
    gap: 6px;
    justify-content: left;
    align-items: flex-start;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title .title {
    display: grid;
    align-items: flex-start;
    gap: 6px;
    grid-template-columns: auto 1fr;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title .title h6 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title h6 {
    color: var(--white);
    font-size: 13px;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title .score_time {
    text-align: right;
    color: var(--white);
    font-weight: 300;
    font-size: 11px;
}
.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .league-title .live-info-data {
    display: none;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info {
    display: grid;
    grid-template-columns: 45% auto 45%;
    justify-content: space-between;
    padding: 20px 0 0;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .team-info-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
}

.playing-team-jersey {
    display: flex;
    align-items: center;
    gap: .5rem;
    justify-content: flex-start;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .team-info-inner .team-title h4 {
    color: var(--white);
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .divider {
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .team-info-inner:last-child {
    justify-content: flex-start;
    flex-direction: row;
}

.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .team-info-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
}
.league-slider-main .wrapper .hl-slider-inner .live-legaue-card .live-card-inner .live-card-content .team-info .team-info-inner .team-title h4 {
    color: var(--white);
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.betting_info {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 5px;
    flex-wrap: wrap;
    gap: 5px;
    align-items: flex-end;
	padding-top: 10px;
	padding-bottom: 10px;
}

.way2 {
    grid-template-columns: 1fr 1fr;
}

.live-legaue-card .live-card-inner:hover .live-card-image:after {
    background: linear-gradient(180deg, rgba(32, 40, 51, .9) 10%, hsla(0, 0%, 100%, 0) 179%);
    opacity: 1;
}

.live-card-inner:hover .live-card-image:after {
    background: linear-gradient(180deg, rgba(32, 40, 51, .9) 10%, hsla(0, 0%, 100%, 0) 179%) !important;
    opacity: 1 !important;
}


.league-slider-main .wrapper .league_slides-inner .live-legaue-card.live-league-match .live-card-inner .live-card-content .league-title .score_time {
    display: none;
}

</style>